<template>
    <div v-loading="loading">
        <hts-form-date
            v-model="filters.dateRange"
            range
            type="dateRange"
            prop="dateRange"
            :placeholder="$t('labels.fromTo')"
            class="max-w-96 max-h-96" />
        <div class="my-4">
            <h2>
                Thống kê số lần qua trạm thu phí
            </h2>
            <hts-data-table
                ref="dataTable"
                class="w-full mt-4"
                :headers="headers()"
                :query-extend="filters"
                row-selection="single"
                enable-cell-change-flash
                :server="$url.report.getTollStation" />
        </div>
    </div>
</template>

<script setup lang="ts">
const { $formatters } = useNuxtApp()
const { reportPage } = $store()
const loading = ref(true)
const vehicleCategories = ref<null | Array<any>>()
const dataTable = ref()

const contTypes = [
  {
    key: '20F',
    title: $t('labels.20f')
  },
  {
    key: '40F',
    title: $t('labels.40f')
  },
  {
    key: '45F',
    title: $t('labels.45f')
  }
]
const headers = () => {
  let headersDefault = [
    {
      field: 'name',
      headerName: $t('labels.tollStation')
    }
  ] as any[]

  const headersCont: any = [
    ...contTypes.map((type) => {
      return {
        headerName: type.title,
        sortable: false,
        valueGetter: (params: any) => {
          const { contCategory } = params.data
          const times = contCategory?.[type.key]
          if (!times) {
            return ''
          }
          return $formatters.formatNumber(times)
        }
      }
    })
  ]

  const headersVehicle: any = [
    ...(vehicleCategories?.value?.map((item: any) => {
      const id = item._id
      return {
        headerName: item.name,
        sortable: false,
        valueGetter: (params: any) => {
          const { vehicleCategory } = params.data
          const times = vehicleCategory?.[id]
          if (!times) {
            return ''
          }
          return $formatters.formatNumber(times)
        }
      }
    }) || [])
  ]

  headersDefault = headersDefault.concat(headersCont)
  headersDefault = headersDefault.concat(headersVehicle)

  return headersDefault
}

const filters = computed({
  get () {
    return reportPage.filters
  },
  set (val: any) {
    reportPage.setFilters(val)
  }
})

onMounted(() => {
  getVehicleCategories()
})

const refreshTable = $lodash.debounce(() => {
  dataTable.value && dataTable?.value?.refresh()
}, 300)

/** Watching */
watch(
  () => filters.value,
  (val: any) => {
    refreshTable()
  },
  { deep: true }
)

const getVehicleCategories = () => {
  const api = $urlAdmin.vehicle.category.getAll
  $api(api)
    .then((data) => {
      const resData: any = data?.data?.value

      if (resData?.success) {
        vehicleCategories.value = resData.data || []
      }

      loading.value = false
    })
    .catch(() => {
      vehicleCategories.value = []
      loading.value = false
    })
}
</script>
